// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__17R8N","info":"UpdateTermsInfo_info__23Y8-"};